import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,

  FormControl,

  FormGroup,
  Validators
} from '@angular/forms';
import { TabPosition } from '@progress/kendo-angular-layout';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { LocationSummary } from '~/models/modules/location';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationTypesService } from '~/services/modules/stocks/location-types';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';

import { AddressesService } from '~/services/modules/stocks/addresses';
import { FilesService } from '~/services/modules/stocks/files';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { BuildingService } from '~/services/modules/stocks/building';
import { Building } from '~/models/modules/building';
import { FloorService } from '~/services/modules/stocks/floor';
import { Floor } from '~/models/modules/floor';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
@Component({
    selector: 'app-floorupsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FloorUpsertComponent extends MultiSiteAwareComponent implements OnInit, OnDestroy, AfterContentChecked {

  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _theme: string;
  accountsiteCount: boolean = false;
  _AddressFiltered: any[];
  _addres: any[];
  _formGroup: FormGroup;
  _active: boolean;
  _isAutoGeneratingNumber: boolean;
  _currentType: string;
  _invalidForm: boolean;
  form: LocationSummary;
  _canEditLocationType: boolean = true;
  _buildingCode = new FormControl();
  _pageState: PageState;
  _showCirclesForm: boolean;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _addClassActive: boolean = false;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _editFormActive: boolean;
  _customFields: CustomFieldSummary[][] = [];
  _page = 'floor';
  _permissionScope = 'floor';
  _customTabs: any;
  _customFieldsValue: any;
  _gridFieldText: GridFieldTextSummary[];
  _language: string = 'en';
  _isRenameLabel: boolean = false;
  _selectedLabelObjectCode: any;
  _isRenameCustomFormValue: boolean = false;
  _selectedLabelId: number;
  _customFieldsDictionary: { [key: string]: string } = {};
  _selectedAccountIds: any[] = [];
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _index: number;
  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _orderingTabsForm: boolean = false;
  _gridFieldAuth: GridFieldAuthorization[];
  _isMandatory: boolean = false;
  _requiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];
  _SiteFiltered: any[];
  _isEditForms: boolean = false;
  _addressFiltered: any[];
  _TransactionFire: boolean = false;
  _isTransactionFire: BehaviorSubject<any>;
  openfromlist: any = false;
  public _donutChartSmall: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
  ];

  public _donutChartLarge: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
    ,
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    }
  ];
  _currentUser: UserSummary;

  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  _NOSActive: boolean = true;
  _INVENTORYIDActive: boolean = false;
  _BCActive: boolean = false;

  getAddresses: any[];
  getpicturefiles: any[];
  getsite: any[];
  getlistofBuilding: any[];
  bilidingFilter: any[];
  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  _addresses: any[];
  locationTypeChart: Chart;
  _stockItemGridColumns: GridFieldSummary[];
  isOpenStockItemForm: boolean = false;
  reactivate: boolean = false;
  reactivateItem: any;
  isStockItemGridExpanded: boolean = true;
  isStockItemChartExpanded: boolean = true;
  _model: Floor;
  modelid: number;
  reloadlist: any;

  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Location_Type_ID') kendoBarcodeGenLocationTypeID: ElementRef;
  @ViewChild('locationTypeDescription') locationTypeDescription: ElementRef;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('note') note: NoteComponent;
  @ViewChild('textarea_address') addressTextarea: ElementRef;
  @ViewChild('kendo_combo_addresses') kendoComboAddresses: ComboBoxComponent;
  //#region Multi Site Variables

  //#endregion
  constructor(
    private _locationTypesService: LocationTypesService,
    private _addressesService: AddressesService,
    private getfilesService: FilesService,
    private _floorServices: FloorService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    public cdRef: ChangeDetectorRef,
    public _stockItemsService: StockItemsService,
    private _sharedService: SharedService,
    private _multiSitesService: MultiSiteService,
    private _buildingService: BuildingService

  ) {
    super();
    this._getdata();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();
    this._currentUser = this._securityService.currentUser;

    this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();


    this._customFieldsService
      .getDeactivatedCustomFields('stock')

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });

    this._isTransactionFire = this._gridLayoutManagerService.sendanybehaviorsubject();

    this.getAuth();

    //#region building Subscription
    this._buildingService.BuildingAdded.subscribe((building: any) => {


      if (!this.getlistofBuilding.find(x => x.id == building.id)) {
        if (!this._currentUser.isEnterprise) {
          if ((this._siteSelected && this._siteSelected.id == building.siteId)
            || !building.siteId
          ) {
            this.getlistofBuilding.push(building);
            this.bilidingFilter = this.getlistofBuilding;
            this._formGroup.get('buildingid').setValue(building);
          }

        }
        else {
          this.getlistofBuilding.push(building);
          this.bilidingFilter = this.getlistofBuilding;
          this._formGroup.get('buildingid').setValue(building);
        }

      }

    })
    this._buildingService.BuildingUpdated.subscribe((building: any) => {
      var UpdatedRecord = this.getlistofBuilding.find(x => x.id == building.id);
      if (UpdatedRecord) {
        var Index = this.getlistofBuilding.indexOf(UpdatedRecord);
        if (Index != -1) {
          this.getlistofBuilding[Index] = building;
          this.bilidingFilter = this.getlistofBuilding;
          this._formGroup.get('buildingid').setValue(building);
        }

      }

    });
    //#endregion
  }

  _selectFacilityOpenCloseHandler(openclose: boolean): void {

  }

  submodel: any;
  _openForm(componentName: string, mainmodel: string = null) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this.submodel = this._sharedService.model.submodel;
    this._dialogModel = { model: {}, pageState: PageState.ADD, reload: 'model', submodel: mainmodel };
  }

  _handleBuilidingFilter(value: any) {
    this.bilidingFilter = this.getlistofBuilding.filter(
      (s) => s.description.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
    this.openfromlist = this._sharedService.model.openfromlist;
    if (this._pageState === PageState.ADD && this._model) {
      this._model.id = null;
      //this._model.code = null;
    }


    if (this._model && this._model.id) {
      this.LoadLocationTypeChart();
    }
  }

  _handleLocationsFilter(value: any) {
    this._AddressFiltered = this._addres.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }


  LoadLocationTypeChart() {
    this._floorServices.GetModelChart(this._model.id)
      .pipe()
      .toPromise()
      .then(async (data: any) => {
        this.locationTypeChart = data;
      });

    this._gridFields
      .getGridFieldsByPage('stockItems')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
        this._stockItemGridColumns = data;
      });

  }


  OnOpenStockItemForm(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.isOpenStockItemForm = true;
  }

  OnCloseStockItemForm() {
    this.isOpenStockItemForm = false;
  }


  _getStockItemByLocationType = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._stockItemsService.GetStockItemByLocationType(this._model.id);
  }


  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }


  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      this._editFormActive = true;
      this._isCustomfieldsFormValue = true;
    }
  }
  _NOSTabClick() {

    this._NOSActive = true;
    this._INVENTORYIDActive = false;
    this._BCActive = false;
  }
  _INVENTORYIDTabClick() {
    this._NOSActive = false;
    this._INVENTORYIDActive = true;
    this._BCActive = false;
  }
  _BCTabClick() {
    this._NOSActive = false;
    this._INVENTORYIDActive = false;
    this._BCActive = true;
  }

  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock')

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });
    this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  this.loadCustomFields(this._model?.id?.toString());
                  this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    this.loadCustomFields(this._model?.id?.toString());
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }
  ngOnInit() {
    this._initForm();
    if (this._pageState == PageState.ADD) {
      // setTimeout(() => {
      //   this.kendoBarcodeGenLocationTypeID.nativeElement.focus();
      // }, 500);
    }

    this.getFormTabs();
    this.getSystemFields();
    if (this._currentUser.isEnterprise)
      this.getBuildingCompoGrid();
    this.getpicturefilesCompoGrid();
    //this.getBuildingCompoGrid();

    if (this._model && this._model.site) {
      this._loadSitesAndInitDD(true, this._model.site);
    }
    else {
      this._loadSitesAndInitDD();
    }

  }


  _barcodeSubmited() {
    this._buildingCode.setValue(this._formGroup.get('code').value);
    if (this._pageState == PageState.ADD) {
      // setTimeout(() => {
      //   this.locationTypeDescription.nativeElement.focus();
      // });
    }
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }
  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }

  _edit() {
    this._pageState = PageState.EDIT;
  }
  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._buildingCode.setValue(data.result.toString());
        this._formGroup.patchValue({
          code: data.result.toString()
        });
        if (this._pageState == PageState.ADD) {
          setTimeout(() => {
            this.locationTypeDescription.nativeElement.focus();
          });
        }
      });
  }
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('floor', quantity);
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  getpicturefilesCompoGrid() {
    return this.getfilesService
      .getPictureFilesSummary()
      .subscribe((data: any) => {
        this.getpicturefiles = data;
      });
  }
  _handleAddressesFilter(value: any) {
    this._SiteFiltered = this._addresses.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  getBuildingCompoGrid() {
    let model = {};
    if (this._currentUser.isEnterprise)
      model = {};
    else
      model = { id: this._siteSelected?.id };
    return this._addressesService
      .getAddressesSiteBuildingSummary(model)
      .subscribe((data: any) => {
        this.getlistofBuilding = data.buildingDto;
        this.bilidingFilter = data.buildingDto;
        this.getsite = data.siteDto;
        this.accountsiteCount = this.getsite.length > 1 ? true : false;
        if (this._formGroup.controls['buildingid'].value
          && !this.getlistofBuilding.find(x => x.id == this._formGroup.controls['buildingid'].value.id)) {
          this._formGroup.controls['buildingid'].setValue(null);
        }

      });
  }

  _handleAddressesChange(value: any) {
    //this.addressTextarea.nativeElement.value = this._fillAddressDetails(value);
    setTimeout(() => {
      //  this.kendoComboAddresses.toggle(false);
    });
  }




  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _onTabSelect(e: any) {

    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  _onSave(e: any) {
    this.submit(e);
  }

  transactionProcess() {
    this._isTransactionFire.next(this._TransactionFire)
  }

  modelupdatedlookup: any;
  _onCancel() {
    this._closeForm(this._sharedService.model.reload != undefined ? this.modelupdatedlookup : '');
  }


  _closeForm(listmodel: any = null) {
    this.reloadlist = this._sharedService.model.reload;
    this.submodel = this._sharedService.model.submodel;

    if (this.submodel !== undefined && this.reloadlist === undefined && this.submodel !== null) {
      this.reloadlist = this.submodel.split('-', 1);
    }

    if (this.openfromlist === true) {
      this.reloadlist = undefined;
    }
    var closeComponent = {
      component: 'floor',
      isClosed: true,
      response: this.reloadlist === undefined ? null : listmodel
    };
    this.transactionProcess();
    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('floor');
    this._layoutManager.setFromChanged('floor');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    if (this.submodel === null || this.submodel === '')
      this._sharedService.model = {};


  }


  private _initForm() {
    this._formGroup = this._fb.group({
      //code: [this._model ? this._model.code : null, Validators.required],
      fileid: [this._model ? this._model.file : null, Validators.required],
      buildingid: [this._model ? this._model.building : null, Validators.required],
      //siteid:[this._model ? this._model.site : null, Validators.required],
      site: [this._model ? this._model.site : null, !this._currentUser.isEnterprise ? Validators.required : null],
      description: [this._model ? this._model.description : null, Validators.required],

    });

  }

  _editFloor = (params?: any) => {
    return this._floorServices.getfloorByID(params)

      .subscribe((model) => {
        this.openUpsert(this._page, model, PageState.EDIT);
      });
  }

  private submit = (e: string) => {

    // if (!this.accountsiteCount){
    //   this._formGroup.controls['siteid'].setErrors(null);
    // }
    if (!this._currentUser.isEnterprise && !this._siteSelected && this.isLoggedInAllSites) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select site to continue.',
        withoutConfirm: true
      });
      return false;
    }
    this._formGroup.controls['site'].setValue(this._siteSelected);

    if (this._formGroup.invalid && this._custominvalidForm) {
      this._invalidForm = true;
      this._invalidSubmit = true;
    } else if (this._formGroup.invalid) {
      this._invalidForm = true;
    } else if (this._custominvalidForm) {
      this._invalidSubmit = true;
    } else {
      // work with custom fields
      if (this._customFieldsValue) {
        const entries = Object.entries(this._customFieldsValue);
        for (const [index, [key, value]] of entries.entries()) {
          this._customFieldsDictionary[key] = `${value}`;
        }
      }

      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._formGroup.value;
      model['buildingid'] = model.buildingid.id ?? model.buildingid;
      model['fileid'] = model.fileid.id ?? model.fileid;
      //model['siteid'] = !this.accountsiteCount ? null : model.siteid.id ?? model.siteid;
      model['siteId'] = this._siteSelected?.id;
      model['id'] = this._model.id,
        model['customFieldsValue'] = this._customFieldsDictionary;
      if (!this._model || !this._model.id) {
        this._floorServices
          .createfloor(model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {

              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true

              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  this._model.id = response.responseId;
                  this.modelid = response.responseId;
                  model.id = this._model.id;
                  this._floorServices.FloorAdded.emit(model);
                  if (e === 'saveAndClose') {
                    model.id = this._model.id;
                    this._closeForm(model);
                    this._TransactionFire = true
                  }
                  else if (e === 'saveAndCopy') {
                    this._formGroup.controls.description.setValue(null);
                    this._pageState = PageState.ADD
                    this._TransactionFire = true
                    // this.openUpsert(this._page, {}, PageState.ADD);
                    this._model.id = null;
                  }
                  else if (e === 'saveAndNew') {
                    this._initForm();
                    this.openUpsert(this._page, {}, PageState.ADD);
                    this._model.id = null;
                    this._TransactionFire = true
                    this._formGroup.reset();
                  }
                  else if (e === 'save' || this.reloadlist != undefined) {
                    model.id = response.responseId;
                    this.modelupdatedlookup = model;
                    if (this.canAccess('floor', 'update')) {
                      if (this._pageState == PageState.ADD) {
                        this._editFloor(model.id);
                        this._TransactionFire = true
                      }
                    }

                  }
                } else {
                  return;
                }
              }
            }

          });
        //================================================UPDATE BUILDING ==================================
      } else {
        this._floorServices
          .updatefloor(model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  this._floorServices.FloorUpdated.emit(model);
                  this._TransactionFire = true
                  if (e === 'saveAndClose') {
                    this._TransactionFire = this.returnParam();
                    this._closeForm();
                  }
                  else if (e === 'saveAndCopy') {
                    this._formGroup.controls.description.setValue(null);
                    this._pageState = PageState.ADD
                    this._TransactionFire = this.returnParam();
                    this._model.id = null;
                  }
                  else if (e === 'saveAndNew') {
                    this.openUpsert(this._page, {}, PageState.ADD);
                    this._model.id = null;
                    this._TransactionFire = this.returnParam();
                    this._formGroup.reset();
                  }
                } else {
                  return;
                }
              }
            }
          });
      }
    }
  }

  returnParam() {
    let returnpara: any = {
      eventvalue: true,
      isviewactive: false
    }
    return returnpara;
  }

  private loadCustomFields(entityId?: string) {
    this._customFieldsService
      .getCustomFields('stock', this._page)

      .subscribe((data) => {
        if (this._model != null && this._model.id != null) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id;
          });
        }
        var tabIds = data.map(item => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(data, (item: { formTabId: any }) => item.formTabId);
        let that = this;
        tabIds.forEach(function (formTabId) {

          that._customFields[formTabId] = grouped.get(formTabId);
        });
      });

    this._customFieldsService
      .getFormTabsByPage(this._page)

      .subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);

      });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }


  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {

    Object.keys(customFieldsValue).forEach(key => {
      if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
        customFieldsValue[key] = '';
      }
      if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
        this._customFields[tabId].find(x => x.name == key).entityId = -1;
        this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: 'null', entityId: -1, customFieldId: -1 });
      }
      var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
      if (customFieldData != undefined) {
        customFieldData.value = customFieldsValue[key];
      }
    });
    this._customFieldsValue = customFieldsValue;
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }

  _deactivateTab(tabId: number, page: string) {

    let model: any = {
      customFieldEntityId: page == 'locationTypes' ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService
      .deleteCustomTab(tabId, model)

      .subscribe((response: any) => {
        if (response != null && response['message'] != null) {
          this._customFieldsService
            .getFormTabsByPage(this._page)

            .subscribe((data: any) => {
              //get custom tabs first
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              // this._closeForm();
            } else {
              return;
            }
          }
        }
        //   this._closeForm();
      });

  }

  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      });
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : null;
    }
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }


  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;
    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }


  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }


  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._closeOrderingTabsForm();
      });
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  getAuth() {
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }


  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
  }

  _closeDialog(event: any) {
    if (event?.response) {

      if (event.component == 'building') {
        //this.getBuildingCompoGrid();
        //this._formGroup.get('buildingid').setValue(event.response);
        this._isDialiog = event.open;
      }
      if (event.component == 'files') {
        this.getpicturefilesCompoGrid();
        this._formGroup.get('fileid').setValue(event.response);
        this._isDialiog = event.open;
      }
    } else {
      this._isDialiog = event;
    }
  }


  ExpandCollapseStockItemGrid(isExpand: boolean) {
    this.isStockItemGridExpanded = !isExpand;
  }


  ExpandCollapseStockItemChart(isExpand: boolean) {
    this.isStockItemChartExpanded = !isExpand;
  }




  getStockItemLeadsString(stockItemLeads: any) {
    let leads = '';
    let counter = 0;
    stockItemLeads.forEach((element: any) => {
      if (counter > 0) {
        leads += ', ';
      }
      leads += element.stockitemleadtime;
      counter++;
    });
    return leads;
  }

  getStockImage(stockItemFiles: any) {
    let files = '';
    let counter = 0;
    stockItemFiles.forEach((element: any) => {
      if (counter > 0) {
        files += ', ';
      }
      files += element.file.thumbnail;
      counter++;
    });
    return files;
  }

  getCategoryImage(categoryFiles: any) {
    let catfiles = '';
    let counter = 0;
    categoryFiles.forEach((element: any) => {
      if (counter > 0) {
        catfiles += ', ';
      }
      catfiles += element.file.thumbnail;
      counter++;
    });
    return catfiles;
  }

  getVendors(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.vendorid;
      counter++;
    });
    return vendor;
  }

  getTimeUnitCode(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.stockItemLeadid;
      counter++;
    });
    return vendor;
  }

  getTimeUnit(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.stockitemleadinterval;
      counter++;
    });
    return vendor;
  }


  getSitesString(accountSites: any, isId: boolean) {
    let sites = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (counter > 0) {
        sites += ', ';
      }
      if (!isId) {
        if (element.site) {
          sites += element.site.name;
        } else {
          sites += 'All Sites';
        }
      }
      else {
        if (element.site) {
          sites += element.site.id;
        }
      }

      counter++;
    });
    return sites;
  }

  getAccountsString(accountSites: any) {
    let accounts = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.account.name;
      counter++;
    });

    return accounts;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  _hasCustomTabs() {
    return this._dataTabs.find((x: any) => x.isCustom);
  }
  //#region Multi Site Functions
  _loadSitesAndInitDD(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      this._sites = data || [];
      this._sitesFiltered = this._sites;

      this.initAllSitesDropDown(IsEdit, SavedSite);

    });
  }
  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
    this.getBuildingCompoGrid();
  }
  _handleSitesChange(event: any) {
    super._handleSitesChange(event);
    this.getBuildingCompoGrid();
  }
  //#endregion

}
